'use client';
import { OrderStatus } from 'database';
import { useTranslations } from 'i11n';
import { Badge, BadgeProps } from 'ui';

// Record-based dispatch: every OrderStatus maps to a Badge variant. Adding a
// status to the enum breaks the build here until it is mapped (F1.4.3).
const ORDER_STATUS_VARIANT: Record<OrderStatus, BadgeProps['variant']> = {
  pending: 'warning', // amber — awaiting provider response
  in_progress: 'warning', // sky — accepted, in progress
  completed: 'success', // green — finalized
  rejected: 'danger', // red — rejected by provider
  canceled: 'neutral', // gray — canceled by insurer
};

export const OrderStatusBadge = ({ status }: { status: OrderStatus }) => {
  const t = useTranslations();
  return (
    <Badge variant={ORDER_STATUS_VARIANT[status]}>
      <span className='whitespace-nowrap'>{t(`orders.status.${status}`)}</span>
    </Badge>
  );
};
